// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__VXnH4","rightAdornment":"Header_rightAdornment__2l66x"};